import { of } from 'rxjs';

export const empty = () => of({});
